import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  titleBlock: { display: 'flex', flexDirection: 'column' },
  subtitle: { color: theme.palette.text.secondary },
  actions: { display: 'flex', alignItems: 'center', gap: theme.spacing(2) }
}))

// One-line explanation + an action slot (e.g. "+ New session"). No title:
// the left panel already names the page (owner, 2026-10-03). At Home has no
// building switcher either: a session's apartment is a column, not a
// page-level context.
const AtHomePageHeader = ({ title, action, subtitle }) => {
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <div className={classes.titleBlock}>
        {title && <Typography variant="h5">{title}</Typography>}
        {subtitle && (
          <Typography variant="body2" className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </div>
      <div className={classes.actions}>{action}</div>
    </div>
  )
}

AtHomePageHeader.propTypes = {
  title: PropTypes.string,
  action: PropTypes.node,
  subtitle: PropTypes.string
}

export default AtHomePageHeader
